export default __webpack_public_path__ + "static/media/promise.2a6fd70b.gif";